const RESERVATION_KEY = "checkout:reservation";

export const savePendingReservation = (reservation) => {
  try {
    sessionStorage.setItem(RESERVATION_KEY, JSON.stringify(reservation));
  } catch {
    /* sessionStorage unavailable — a redirect-return just won't recover the reservation */
  }
};

export const readPendingReservation = () => {
  try {
    const raw = sessionStorage.getItem(RESERVATION_KEY);

    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearPendingReservation = () => {
  try {
    sessionStorage.removeItem(RESERVATION_KEY);
  } catch {
    /* nothing to clear */
  }
};
